// extracted by mini-css-extract-plugin
export var billingAddress = "_yg-g";
export var contactInfo = "_yg-d";
export var customerInfoContainer = "_yg-c";
export var customerInfoContainerMobile = "_yg-h";
export var customerInfoRow = "_yg-a";
export var customerInfoSection = "_yg-b";
export var fullWidthDividerMobile = "_yg-i";
export var imageContainer = "_yg-1";
export var paymentMethod = "_yg-e";
export var priceText = "_yg-6";
export var priceTextMobile = "_yg-7";
export var product = "_yg-0";
export var productImage = "_yg-2";
export var productInfo = "_yg-4";
export var productMobile = "_yg-9";
export var productTitle = "_yg-8";
export var quantityBadge = "_yg-3";
export var quantityText = "_yg-5";
export var shippingAddress = "_yg-f";